export function copyright()
{
    var el = document.querySelector('.copyright');
    if(el) {
        var rangeEnd = new Date();
        el.innerHTML = '&copy;2010 - 2020 Medicōs Consultants LLC. All rights reserved.';
    }
}

